/* Cross & Crown — shared accessibility helpers.
   Escape-to-close and focus-return, nothing else. No polyfills, no framework,
   no network. Every consumer must still work with this file absent. */
(function () {
  'use strict';

  /* Focus without moving the viewport. Focusing a clipped control without
     preventScroll is what produces the scroll-jump on variant change. */
  function focus(el) {
    if (!el || typeof el.focus !== 'function') return;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      el.focus();
    }
  }

  /* Run handler when Escape is pressed inside el. Returns a detach function. */
  function onEscape(el, handler) {
    if (!el || typeof handler !== 'function') return function () {};
    function keydown(event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      handler(event);
    }
    el.addEventListener('keydown', keydown);
    return function () {
      el.removeEventListener('keydown', keydown);
    };
  }

  /* Wire a <details> panel: Escape closes it and returns focus to its
     <summary>; a click outside closes it without stealing focus. Returns a
     detach function so a custom element can clean up on disconnect. */
  function bindDetails(details) {
    if (!details || details.tagName !== 'DETAILS') return function () {};
    var summary = details.querySelector('summary');

    function close(returnFocus) {
      if (!details.open) return;
      details.open = false;
      if (returnFocus) focus(summary);
    }

    var detachEscape = onEscape(details, function (event) {
      event.stopPropagation();
      close(true);
    });

    function outside(event) {
      if (!details.open) return;
      if (details.contains(event.target)) return;
      close(false);
    }
    document.addEventListener('click', outside);

    return function () {
      detachEscape();
      document.removeEventListener('click', outside);
    };
  }

  /* First focusable descendant, for moving focus into a panel on open. */
  function firstFocusable(el) {
    if (!el) return null;
    return el.querySelector(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
    );
  }

  window.ccA11y = {
    focus: focus,
    onEscape: onEscape,
    bindDetails: bindDetails,
    firstFocusable: firstFocusable,
  };
})();
